"use client";

import { dynamicChart } from "@/components/charts/dynamicChart";

export type { CostPerPermitByTermProps } from "./CostPerPermitByTermChart.impl";

export const CostPerPermitByTermChart = dynamicChart(
  () => import("./CostPerPermitByTermChart.impl").then((m) => m.CostPerPermitByTermChart),
  320,
);
